export enum PropertyProviderModes {
    SingleProperty = "single-property",
    MultiProperty = "multi-property",
}
